import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { OrchestratorService } from '@services/orchestrator/orchestrator.service';
import { Observable, catchError, map, of } from 'rxjs';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const orchestrator: OrchestratorService = inject(OrchestratorService);

  return orchestrator.initializeContext().pipe(
    catchError(() => of(false)),
    map((res: boolean) => state.url.startsWith('/auth/') || res)
  );
};
